import Units from "utils/units" // eslint-disable-line import/no-named-as-default
import { setPermanentCookie } from "utils/permanent-cookie"

export class MobileUnitSwitcher {
  private lengthMetricRadio?: HTMLInputElement
  private lengthImperialRadio?: HTMLInputElement
  private speedMetricRadio?: HTMLInputElement
  private speedImperialRadio?: HTMLInputElement
  private tempMetricRadio?: HTMLInputElement
  private tempImperialRadio?: HTMLInputElement

  constructor() {
    this.initializeElements()
    this.setInitialStates()
    this.addEventListeners()
  }

  private static saveUnitsChoice(
    _unitType: "length" | "speed" | "temperature",
    value: "Metric" | "Imperial",
  ) {
    setPermanentCookie("u", value === "Imperial" ? "i" : "m")
  }

  private initializeElements() {
    const getElement = (selector: string) => {
      const element = document.querySelector(selector)
      return element ? (element as HTMLInputElement) : undefined
    }

    this.lengthMetricRadio = getElement(".menu-nav__settings-input--length-met")
    this.lengthImperialRadio = getElement(".menu-nav__settings-input--length-imp")
    this.speedMetricRadio = getElement(".menu-nav__settings-input--speed-met")
    this.speedImperialRadio = getElement(".menu-nav__settings-input--speed-imp")
    this.tempMetricRadio = getElement(".menu-nav__settings-input--temp-met")
    this.tempImperialRadio = getElement(".menu-nav__settings-input--temp-imp")
  }

  private setInitialStates() {
    if (this.lengthMetricRadio) this.lengthMetricRadio.checked = Units.length === "Metric"
    if (this.lengthImperialRadio) this.lengthImperialRadio.checked = Units.length === "Imperial"
    if (this.speedMetricRadio) this.speedMetricRadio.checked = Units.speed === "Metric"
    if (this.speedImperialRadio) this.speedImperialRadio.checked = Units.speed === "Imperial"
    if (this.tempMetricRadio) this.tempMetricRadio.checked = Units.temperature === "Metric"
    if (this.tempImperialRadio) this.tempImperialRadio.checked = Units.temperature === "Imperial"
  }

  private addEventListeners() {
    this.lengthMetricRadio?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ length: "Metric" })
        MobileUnitSwitcher.saveUnitsChoice("length", "Metric")
      }
    })

    this.lengthImperialRadio?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ length: "Imperial" })
        MobileUnitSwitcher.saveUnitsChoice("length", "Imperial")
      }
    })

    this.speedMetricRadio?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ speed: "Metric" })
        MobileUnitSwitcher.saveUnitsChoice("speed", "Metric")
      }
    })

    this.speedImperialRadio?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ speed: "Imperial" })
        MobileUnitSwitcher.saveUnitsChoice("speed", "Imperial")
      }
    })

    this.tempMetricRadio?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ temperature: "Metric" })
        MobileUnitSwitcher.saveUnitsChoice("temperature", "Metric")
      }
    })

    this.tempImperialRadio?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ temperature: "Imperial" })
        MobileUnitSwitcher.saveUnitsChoice("temperature", "Imperial")
      }
    })
  }
}
